import { GridColDef, GridRenderCellParams, GridValueFormatterParams } from '@mui/x-data-grid';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useTranslation } from 'react-i18next';

import GridListAction from 'modules/maya/components/GridListAction/GridListAction';

const useCiTemplateListConfig = (
  editCiTemplateCallback: (ciId: string) => void,
  duplicateCiTemplateCallback: (ciId: string) => void,
  addChildCallback: (ciId: string) => void,
  openModalCallback: (ciId: string) => void,
) => {
  const { t } = useTranslation();
  const flags = useFlags();

  const ciTitleFieldConfig = {
    label: t('maya_ci_tpl_title_label'),
    name: 'name',
    placeholder: t('maya_ci_tpl_title_placeholder'),
    defaultValue: '',
    required: false,
  };

  const customerInitiativeListColumnConfig: GridColDef[] = [
    {
      field: 'title',
      headerName: t('maya_ci_tpl_list_initiative_name_header_label'),
      flex: 0.2,
      sortable: false,
      cellClassName: 'gridlist-cell-bold',
    },
    {
      field: 'therapeuticArea',
      headerName: t('maya_customer_initiative_list_TA_header_label'),
      flex: 0.05,
      sortable: false,
    },
    {
      field: 'product',
      headerName: t('maya_customer_initiative_list_product_header_label'),
      valueGetter: (params: GridValueFormatterParams) => {
        return params.value?.toString() || '';
      },
      flex: 0.10,
      sortable: false,
    },
    {
      field: 'functionalOwner',
      headerName: t('maya_customer_initiative_form_functional_owner_label'),
      flex: 0.1,
      sortable: false,
    },
    {
      field: 'updated',
      type: 'date',
      headerName: t('maya_customer_initiative_list_last_update_header_label'),
      valueFormatter: (params: GridValueFormatterParams) => {
        const date = new Date(params.value as string);
        return date.toLocaleString();
      },
      flex: 0.1,
      sortable: false,
    },
    {
      field: 'action',
      headerName: '',
      disableColumnMenu: true,
      hideSortIcons: true,
      renderCell: (params: GridRenderCellParams) => {
        const actions = [
          {
            label: t('actions_edit_label'),
            callback: () => { editCiTemplateCallback(params.row._id); },
          },
          {
            label: t('actions_ci_from_tpl_label'),
            callback: () => { duplicateCiTemplateCallback(params.row._id); },
          },
          {
            label: t('maya_customer_initiative_list_add_child_cep'),
            callback: () => { addChildCallback(params.row._id); },
          },
        ];

        if (flags.mayaBiogenlinc3810EnableCiDeleting) {
          actions.push({
            label: t('maya_action_delete_ci_label'),
            callback: () => {
              openModalCallback(params.row._id);
            },
          });
        }

        return (
          <GridListAction
            actions={ actions }
          />
        );
      },
      align: 'right',
      headerAlign: 'right',
      flex: 0.05,
      sortable: false,
    },
  ];

  return { customerInitiativeListColumnConfig, ciTitleFieldConfig };
};

export default useCiTemplateListConfig;
